module.exports = __webpack_public_path__ + "img/3.301bc3e1.jpg";